import { thunk, action } from 'easy-peasy'
import { notification } from 'antd'

import { loginApi, getUser } from 'services/auth'

const initialState = {
  isChecked: false,
  isLogin: false,
  user: {},
  menu: [],
  org: {},
}

const model = {
  ...initialState,

  reset: action((state, payload) => {
    state = {
      ...initialState,
      isChecked: true,
    }
  }),

  setChecked: action((state, payload) => {
    state.isChecked = payload
  }),

  setLogin: action((state, payload) => {
    state.isLogin = payload
  }),

  setUser: action((state, payload) => {
    state.user = payload
    localStorage.setItem('user', JSON.stringify(payload))
  }),

  setOrg: action((state, payload) => {
    state.org = payload
    localStorage.setItem('org', JSON.stringify(payload))
  }),

  setMenu: action((state, payload) => {
    state.menu = payload
  }),

  login: thunk(async (actions, payload) => {
    const loginResult = await loginApi(payload)
    localStorage.clear()

    if (loginResult.status === 'success') {
      let menu = loginResult?.data?.user?.profile?.menus
      if (menu) {
        localStorage.setItem('menu', menu ? JSON.stringify(menu) : '')

        const u = await getUser({
          // profile_id: loginResult?.data?.user?.profile_id,
          employee_name: loginResult?.data?.user?.employee?.employee_name_th,
          token: loginResult?.data?.access_token,
        })
        if (u.status === 'success') {
          console.log('--------', u?.data)
          if (u?.data?.items[0]?.employee?.org_structure) {
            actions.setOrg(u?.data?.items[0]?.employee?.org_structure)
          }
        }
        localStorage.setItem('token', loginResult?.data?.access_token)

        localStorage.setItem('isLogin', true)
        notification.success({
          message: 'Success',
          description: 'Login Success.',
          placement: 'topRight',
        })
        actions.setUser(loginResult?.data?.user)
        actions.setMenu(loginResult?.data?.user?.profile?.menus)
        actions.setLogin(true)
        setTimeout(function () {
          window.location.reload()
        }, 600)
      } else {
        notification.error({
          message: 'Failed',
          description: 'ข้อมูลProfileไม่ถูกต้อง กรุณาติดต่อแอดมิน',
        })
      }
    } else {
      notification.error({
        message: 'Failed',
        description: loginResult.message,
      })
    }

    actions.setChecked(true)
  }),

  logout: thunk(async (actions, payload) => {
    actions.reset()
    actions.setLogin(false)
  }),
}

export default model
